import { render } from "./ViewProduit.vue?vue&type=template&id=03270e21&ts=true"
import script from "./ViewProduit.vue?vue&type=script&lang=ts"
export * from "./ViewProduit.vue?vue&type=script&lang=ts"

import "./ViewProduit.vue?vue&type=style&index=0&id=03270e21&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__